module.exports = __webpack_public_path__ + "static/img/progress.87bfe4e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress.svg
// module id = kpY/
// module chunks = 1